import { useQuery } from '@apollo/client';

import {
  useTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';
import { getVendorDataMapper } from '@eluve/vendor';

import { getTenantLocationUsersQuery } from './LocationUsers';

export const useUserLocations = () => {
  const tenantId = useTenantIdFromParams();
  const userId = useUserIdFromSession();
  const { data } = useQuery(getTenantLocationUsersQuery, {
    variables: {
      tenantId: tenantId!,
    },
    skip: !tenantId,
  });

  const locations = data?.tenantsByPk?.locations ?? [];
  const isUserPartOfAnyLocation = locations.some((location) =>
    location.location_users?.some((user) => user.userId === userId),
  );
  const userLocations = locations.filter((location) =>
    location.location_users?.some((user) => user.userId === userId),
  );
  const areLocationsAvailable = locations.length >= 1;
  const isAnyLocationEhrEnabled = userLocations.some((location) => {
    if (!location.externalEhr) {
      return false;
    }

    const provider = getVendorDataMapper(location.externalEhr.vendor);
    return provider.getSyncConfig().isSyncEnabled;
  });

  const locationUserExternalEhrs = userLocations
    .filter((location) => location.externalEhr)
    .map((location) => {
      return {
        id: location.externalEhr!.id,
        vendor: location.externalEhr!.vendor,
        domain: location.externalEhr!.domain,
      };
    });

  return {
    locationUserExternalEhrs,
    isUserPartOfAnyLocation,
    userLocations,
    areLocationsAvailable,
    isAnyLocationEhrEnabled,
  };
};
